import { FC } from 'react';
import Sparkle from '@components/Icons/Sparkle';
import { WORKFLOW_TRIGGERS, WorkflowStep } from '@typings/api-models';

import NativeSelect from '@components/FormFields/NativeSelectV2';
import classes from './TriggerCard.module.scss';

const TRIGGER_OPTIONS = [
  {
    title: 'An empty trigger for testing only',
    value: WORKFLOW_TRIGGERS.TEST_TRIGGER,
  },
  {
    title: 'On Purchase',
    value: WORKFLOW_TRIGGERS.PRODUCT_PURCHASED,
  },
  {
    title: 'When Shopping Cart is Abandoned',
    value: WORKFLOW_TRIGGERS.CART_ABANDONED,
  },
  {
    title: 'When a Booking is Upcoming',
    value: WORKFLOW_TRIGGERS.UPCOMING_BOOKING,
  },
  {
    title: 'On Document Upload Complete',
    value: WORKFLOW_TRIGGERS.DOCUMENTS_UPLOADED,
  },
  {
    title: 'Initiate the Workflow on a CTA',
    value: WORKFLOW_TRIGGERS.INITIATE_CTA,
  },
  {
    title: 'On Form Complete',
    value: WORKFLOW_TRIGGERS.FORM_REQUEST_COMPLETED,
  },
];

type TriggerCardProps = {
  availableTriggers: WORKFLOW_TRIGGERS[];
  trigger: Pick<WorkflowStep, 'eventName' | 'id'>;
  updateStep: (data: { stepId: string; updates: Pick<WorkflowStep, 'eventName'> }) => void;
};

const TriggerCard: FC<TriggerCardProps> = ({ availableTriggers, trigger, updateStep }) => {
  // availableTriggers changes on every render, so don't bother with useState/useMemo
  const triggerOptions = TRIGGER_OPTIONS.filter(option => (
    availableTriggers.includes(option.value)
    || option.value === trigger.eventName
  ));

  const handleChange = (tValue: WORKFLOW_TRIGGERS): void => {
    updateStep({ stepId: trigger.id, updates: { eventName: tValue } });
  };

  return (
    <div className={classes.triggerContainer}>
      <div className={classes.header}>
        <Sparkle weight='fill' size='16'/>
        <p className='caption-bold'>Trigger</p>
      </div>
      <div>
        <div className={classes.triggerSelector}>
          <NativeSelect
            id={'triggers'}
            onChange={(val) => handleChange(val as WORKFLOW_TRIGGERS)}
            options={triggerOptions}
            value={trigger.eventName}
          />
        </div>
      </div>
    </div>
  );
};

export default TriggerCard;
